import RaceMixins from '../../../../components/_mixins/races'
import DatesMixin from '../../../../components/_mixins/dates'

export default {
  name: 'mini-cart',
  mixins: [RaceMixins, DatesMixin],
  data() {
    return {
    }
  },
  computed: {
    accessoriesItems() {
      return this.productAccessories
    },
    hasAccessoriesItems() {
      return !_.isEmpty(this.accessoriesItems)
    },
    miniCartItems() {
      return this.selectedTimeslots
    },
    selectedFirstSlot() {
      return _.first(this.miniCartItems)
    },
    selectedProductTitle() {
      return this.selectedFirstSlot.item.reservationProduct.title
    },
    selectedSlotDateTime() {
      return this.selectedSlotDate + ', ' + this.selectedSlotTime
    },
    selectedSlotDate() {
      return this.selectedFirstSlot.date
    },
    selectedSlotTime() {
      return this.selectedFirstSlot.time
    },
    selectedHours() {
      return this.numberOfHours
    },
    selectedParticipants() {
      return this.totalPlayers
    },
    selectedProductPrice() {
      return 1 * this.selectedFirstSlot.item.reservationProduct.rate * 2
    },
    slottedDate() {
      return this.formatDate(this.selectedDate, 'M/d/y')
    },
    subTotal() {
      return _.reduce(this.miniCartItems, (total, slot) => {
        return total + (slot.racers * slot.item.reservationProduct.rate)
      }, 0)
    },
    taxTotal() {
      return _.reduce(this.miniCartItems, (total, slot) => {
        return total + (slot.racers * slot.item.reservationProduct.tax_amount)
      }, 0)
    },
    netTotal() {
      return this.subTotal + this.taxTotal
    },
    allSubTotal() {
      return this.subTotal + _.reduce(this.accessoriesItems, (total, item) => {
        return total + (item.count * item.product.price)
      }, 0)
    },
    allTaxTotal() {
      return this.taxTotal + _.reduce(this.accessoriesItems, (total, item) => {
        return total + (item.count * item.product.tax_amount)
      }, 0)
    },
    allNetTotal() {
      return this.allSubTotal + this.allTaxTotal
    },
  },
  methods:{
    itemRacerLimit(slot) {
      const playerLimit = this.totalPlayers
      return Math.min(slot.karts, playerLimit)
    },
    addRacerToSlot(slot, quantity) {
      const value = (slot.racers || 0) + quantity
      this.setTimeslotData({time: slot.time, key: 'racers', value: value})
    },
    getItemSubTotal(slot) {
      const quantity = slot.racers * 1
      return quantity * slot.item.reservationProduct.rate
    },
    getItemTaxTotal(slot) {
      const quantity = slot.racers * 1
      return quantity * slot.item.reservationProduct.tax_amount
    },
    getItemTotal(slot) {
      return this.getItemSubTotal(slot) + this.getItemTaxTotal(slot)
    },
  }
}
